import { LucideProps } from 'lucide-react'

const Guarantee = (props: LucideProps) => (
  <svg
    viewBox="0 0 38 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4834 5.39453V34.9226L18.8115 30.665L26.1138 34.9226V5.39453H11.4834Z"
      fill="#E2D9C9"
    />
    <path
      d="M18.7982 26.7254C25.7409 26.7254 31.368 21.0983 31.368 14.1557C31.368 7.21302 25.7409 1.58594 18.7982 1.58594C11.8556 1.58594 6.22852 7.21302 6.22852 14.1557C6.22852 21.0983 11.8556 26.7254 18.7982 26.7254Z"
      fill="#DB4345"
    />
    <path
      d="M22.3767 8.91135L17.1284 14.5391L19.7328 16.9678L24.9811 11.3401L22.3767 8.91135Z"
      fill="white"
    />
    <path
      d="M15.0396 12.2703L12.6108 14.875L17.4651 19.4013L19.8938 16.7967L15.0396 12.2703Z"
      fill="white"
    />
  </svg>
)

export default Guarantee
